/**
 * 路由路径枚举 —— 全项目路径字面量的唯一来源。
 * 新增路由:先在这里加一项,再到 src/routers.js 注册(并到 RouteTracker 补埋点页面名)。
 */
export const ROUTE_PATHS = {
  /** 当前订阅 + 权益配额 */
  SERVICE: '/service',
  /** 套餐列表 */
  PLAN: '/plan',
  /** 套餐对比 */
  DIFF: '/diff',
  /** 选择国家/地区(未确认国家时拦下) */
  REGION: '/region',
  /** SIM 卡管理 */
  SIM: '/sim',
  /** 错误页 */
  ERROR: '/error',
  /** 兜底路由:未匹配的路径都落到它 */
  FALLBACK: '*',
};
